<template>
    <div class="m-imageAuth">
        <ul class="tips">
            <li>请上传本人身份证，确保图标清晰，无任何遮挡</li>
            <li>请尽量让身份证照片占满整个屏幕，并且露出身份证边缘</li>
            <li>支持图片格式 jpg/jpeg/png/bmp，大小不超过 4M</li>
        </ul>

        <el-form class="image-form" v-model="imageForm">
            <el-form-item label="身份证姓名面照片" prop="front">
                <el-upload
                    :auto-upload="false"
                    class="image-uploader"
                    accept=".jpg,.jpeg,.bmp,.png"
                    :show-file-list="false"
                    list-type="picture-card"
                    :on-change="onFrontChange"
                    :before-upload="beforeImageUpload"
                    :disabled="!!imageForm.front"
                >
                    <template v-if="imageForm.front">
                        <img class="upload-image" id="front-image" :src="imageForm.front.url" v-viewer alt="正面照">
                        <div class="mask">
                            <i class="el-icon-zoom-in" @click.stop="previewImage('front')" title="预览图片"></i>
                            <i class="el-icon-delete" @click.stop="imageForm.front=''" title="删除图片"></i>
                        </div>
                    </template>

                    <div v-else slot="default" class="prepare-upload">
                        <i class="nucfont inuc-idcard_front"></i>
                        <p>点击上传</p>
                    </div>
                </el-upload>
            </el-form-item>


            <el-form-item label="身份证国徽面照片" prop="back">
                <el-upload
                    :auto-upload="false"
                    class="image-uploader"
                    accept=".jpg,.jpeg,.bmp,.png"
                    :show-file-list="false"
                    list-type="picture-card"
                    :on-change="onBackChange"
                    :before-upload="beforeImageUpload"
                    :disabled="!!imageForm.back"
                >
                    <template v-if="imageForm.back">
                        <img class="upload-image" id="back-image" :src="imageForm.back.url" v-viewer alt="背面照">
                        <div class="mask">
                            <i class="el-icon-zoom-in" @click.stop="previewImage('back')" title="预览图片"></i>
                            <i class="el-icon-delete" @click.stop="imageForm.back=''" title="删除图片"></i>
                        </div>
                    </template>

                    <div v-else slot="default" class="prepare-upload">
                        <i class="nucfont inuc-idcard_back"></i>
                        <p>点击上传</p>
                    </div>
                </el-upload>
            </el-form-item>
        </el-form>

        <div class="btn-group">
            <el-button-group>
                <el-button @click="$emit('stepChange', -1)">上一步</el-button>

                <el-button type="primary" @click="saveImageForm"
                           :disabled="!imageForm.front || !imageForm.back"
                           :loading="loading"
                >
                    <span v-if="!loading">下一步</span>
                    <span v-else>验证中</span>
                </el-button>
            </el-button-group>
        </div>

        <el-dialog
            title="验证失败"
            top="30vh"
            class="auth-img-error-dialog"
            :visible.sync="errorDialog"
            width="400px"
            :append-to-body="true"
            :modal-append-to-body="true"
        >
            <div v-if="!errorMsg.isFrontOK">
                <el-tag type="danger" size="small">姓名面照片</el-tag>
                <p class="text">{{errorMsg.frontError}}</p>
            </div>
            <div v-if="!errorMsg.isBackOK">
                <el-tag type="danger" size="small">国徽面照片</el-tag>
                <p class="text">{{errorMsg.backError}}</p>
            </div>
            <div slot="footer">
                <el-button type="primary" size="small" @click="errorDialog = false">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        props: ['initData'],
        data() {
            return {
                imageForm: {
                    front: '',
                    back: '',
                    frontDirty: false,
                    backDirty: false
                },
                errorDialog: false,
                errorMsg: {},
                loading: false
            }
        },

        mounted() {
            if (this.initData && this.initData.idCard) {
                let idCard = this.initData.idCard
                if (idCard.frontURL) {
                    this.imageForm.front = {
                        url: idCard.frontURL
                    }
                }
                if (idCard.backURL) {
                    this.imageForm.back = {
                        url: idCard.backURL
                    }
                }
            }
        },

        methods: {
            saveImageForm() {
                if (!this.imageForm.front) {
                    return this.$message.error('请上传身份证姓名面照片！')
                }
                if (!this.imageForm.back) {
                    return this.$message.error('请上传身份证国徽面照片！')
                }

                let formData = new FormData();

                if (this.imageForm.frontDirty) {
                    formData.append('front', this.imageForm.front.raw);
                }
                if (this.imageForm.backDirty) {
                    formData.append('back', this.imageForm.back.raw);
                }

                this.loading = true
                this.$api.postRealNameImage(formData).then(res => {
                    let data = res.package
                    this.loading = false

                    // 提交的数据没问题
                    if (!data.frontError && !data.backError) {
                        this.imageForm.frontDirty = false
                        this.imageForm.backDirty = false
                        this.$emit('stepChange', 1)

                        // 提交的数据有问题
                    } else {
                        this.errorMsg = data
                        this.errorDialog = true
                    }
                }).catch(error => {this.loading = false})
            },

            onFrontChange(file) {
                this.imageForm.front = file
                this.imageForm.frontDirty = true
            },
            onBackChange(file) {
                this.imageForm.back = file
                this.imageForm.backDirty = true
            },
            beforeImageUpload(file) {
                const isSizeValid = file.size / 1024 / 1024 < 4
                if (!isSizeValid) {
                    this.$message.error("图片大小不能超过4M！")
                }
                return isSizeValid
            },
            previewImage(category) {
                $(`#${category}-image`)[0].$viewer.show()
            }
        },
    }
</script>

<style lang="scss">
    .m-imageAuth {

        .image-form {
            padding-top: 10px;
        }

        .image-uploader {
            .el-upload--picture-card {
                position: relative;
                width: 300px;
                overflow: hidden;
                line-height: 1.6;

                &:hover {
                    .btn-close {
                        display: block;
                        opacity: 1;
                    }

                    .mask {
                        opacity: 1;
                    }

                    .prepare-upload {
                        .nucfont, p {
                            color: #22B9FF;
                        }
                    }
                }
            }

            .upload-image {
                max-width: 100%;
                max-height: 100%;
            }

            .mask {
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                opacity: 0;
                background-color: rgba(0, 0, 0, .5);
                transition: opacity .3s;
                cursor: default;

                i {
                    color: #fff;
                    font-size: 22px;
                    cursor: pointer;

                    + i {
                        margin-left: 50px;
                    }
                }
            }

            .prepare-upload {
                .nucfont, p {
                    color: #aaa;
                    transition: all .3s;
                }

                .nucfont {
                    font-size: 66px;
                }
            }
        }
    }

    .auth-img-error-dialog {
        .text {
            padding: 10px;
        }
        .el-dialog__body {
            padding-bottom: 0;
        }
        .el-dialog__footer {
            padding: 0 20px 15px 15px;
        }
    }
</style>
